<template>
  <div class="layout--full-page">
    <div
      class="h-screen flex-col w-full bg-img vx-row no-gutter items-center justify-center text-center p-3"
      id="page-login"
    >
      <h1 class="mb-3">شما دسترسی به این پنل مدیریت ندارید.</h1>
      <h5 style="max-width: 650px; line-height: 26px">
        ممکن است شماره شما از مجموعه حذف شده یا هنوز به هیچ مجموعه‌ای اختصاص
        داده نشده باشد. در صورت نیاز، لطفاً با مدیر مجموعه خود تماس بگیرید.
      </h5>

      <div class="flex items-center mt-10 gap-4">
        <vs-button @click="onRetry"> تلاش مجدد </vs-button>
        <logout />
      </div>
    </div>
  </div>
</template>

<script>
import Logout from "../../layouts/components/Logout.vue";

export default {
  components: { Logout },
  computed: {
    managedProviders() {
      return this.$store.state.profile.managedProviders.data;
    },
  },
  methods: {
    onRetry() {
      this.$router.go();
    },
  },
};
</script>
